module.exports = __webpack_public_path__ + "static/tahoe-53f874dde37a96cae5d38e5dd65d75f4.jpg";